import { combineReducers } from "redux";
import userkyc from "../features/admin/kyc/userkyc/Slice";




const kyc = combineReducers({
   userkyc: userkyc,
  
  });
  
  export default kyc;